import React from 'react';
import { motion } from 'framer-motion';
import { FiExternalLink, /*FiGithub*/ } from 'react-icons/fi';

import LADDA from "../../assets/portfolio.png";
import DRYVA from "../../assets/dryva.png";
import OPPORTUNIK from "../../assets/opportunik.png";
import ULESSON from "../../assets/uLesson.png";
import COC from "../../assets/cocHymn.png";
import SPOTTR from "../../assets/spottr.png";

const projects = [
  {
    title: "uLesson Educational App",
    description: "An educational platform aimed at delivering high-quality, engaging curriculum-relevant video lessons.",
    tech: ["Android", "Kotlin", "Jetpack Compose", "MVVM", "Clean Architecture", "Hilt", "Room", "WorkManager", "Retrofit"],
    link: "https://play.google.com/store/apps/details?id=com.ulesson.classboard",
    image: ULESSON,
    gradient: "from-emerald-500 to-teal-900"
  },
  {
    title: "Opportunik",
    description: "A cross-platform app connecting African/diasporan investors to curated global funds with secure KYC and wallet management. CIMA-licensed.",
    tech: ["Flutter", "Dart", "Firebase", "REST", "Bloc", "Dio", "Local Auth", "Biometrics", "Secure Storage", "Localization", "Syntry"],
    link: "https://play.google.com/store/apps/details?id=com.opportunik",
    image: OPPORTUNIK,
    gradient: "from-blue-600 to-indigo-900"
  },
  {
    title: "Ladda",
    description: "A one stop investment platform providing access to savings, mutual funds, and stocks in Naira and Dollars.",
    tech: ["Flutter", "Dart", "Monnify", "Flutterwave", "Provider", "Firebase", "Dio"],
    link: "https://play.google.com/store/apps/details?id=com.ladda.production",
    image: LADDA,
    gradient: ""
  },
  {
    title: "Dryva",
    description: "An end-to-end supply chain and ride-hailing solution connecting drivers and riders with real-time tracking.",
    tech: ["Android", "Kotlin", "Google Maps SDK", "Coroutines", "LiveData", "Hilt", "Room", "WorkManager", "Retrofit"],
    link: "https://play.google.com/store/apps/details?id=com.dryva.driver",
    image: DRYVA,
    gradient: ""
  },
  {
    title: "COC Devotional and Hymns",
    description: "A mobile application providing daily devotionals and classic hymns for offline access.",
    tech: ["Flutter", "Dart", "MVVM", "Clean Architecture", "Provider", "Firebase", "Dio"],
    link: "https://play.google.com/store/apps/details?id=com.coc.coc_devotional_and_hymn",
    image: COC,
    gradient: "from-orange-500 to-red-900"
  },
  {
    title: "SPOTTR",
    description: "Find anything you want, from anywhere in the world, using our interactive map and smart search feature.",
    tech: ["Android", "Kotlin", "WebSockets", "Paystack", "Google Maps SDK", "MVVM", "Clean Architecture", "Dagger", "Room", "WorkManager", "Retrofit"],
    link: "https://play.google.com/store/apps/details?id=com.spottr.android.app",
    image: SPOTTR,
    gradient: "from-purple-600 to-fuchsia-900"
  },
];

const Work = () => {
  return (
    <section id='work' className='py-24 bg-[#040811] relative'>
      <div className='max-w-7xl mx-auto px-6 lg:px-8'>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className='text-3xl md:text-5xl font-bold text-white mb-4'>Selected Projects</h2>
          <div className="h-1 w-20 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="group relative bg-slate-800/50 border border-slate-700/50 rounded-2xl overflow-hidden hover:-translate-y-2 transition-transform duration-300"
            >
              <div className={`h-48 w-full relative overflow-hidden ${project.image ? '' : `bg-gradient-to-br ${project.gradient}`}`}>
                {project.image && (
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                  />
                )}
                <div className="absolute inset-0 bg-slate-900/40 group-hover:bg-transparent transition-colors duration-300"></div>
              </div>

              <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-2xl font-bold text-white group-hover:text-primary transition-colors">{project.title}</h3>
                  <div className="flex space-x-3">
                    {project.link !== "#" && (
                      <a href={project.link} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-white transition-colors">
                        <FiExternalLink size={20} />
                      </a>
                    )}
                  </div>
                </div>

                <p className="text-slate-400 text-sm mb-6 leading-relaxed line-clamp-3">
                  {project.description}
                </p>

                <div className="flex flex-wrap gap-2 mt-auto">
                  {project.tech.map((tech, tIdx) => (
                    <span key={tIdx} className="text-xs font-medium text-secondary bg-secondary/10 px-3 py-1 rounded-full">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Work;
